<template>
  <a-modal
    :centered="true"
    :confirmLoading="loading"
    :destroyOnClose="true"
    :title="$t('button.editLocation')"
    :visible="visible"
    width="60%"
    @cancel="handleCancel"
    @ok="handleOk">
    <a-spin :spinning="loading">
      <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="location" :rules="rules" :wrapper-col="wrapperCol" style="margin-left: -2%;margin-right: 2%">
        <a-row>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.locationNo')" prop="no">
              <a-input v-model="location.no"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.locationName')" prop="name">
              <a-input v-model="location.name"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.storageRoom')" prop="storageRoom">
              <a-input-search v-model="location.storageRoom.name" readOnly @dblclick="onStorageRoomSelect" @search="onStorageRoomSelect"/>
            </a-form-model-item>
            <storage-room-modal ref="storageRoomModal" @change="onStorageRoomChange"/>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.zone')" prop="zone">
              <a-input-search v-model="location.zone.name" readOnly @dblclick="onZoneSelect" @search="onZoneSelect"/>
            </a-form-model-item>
            <zone-modal ref="zoneModal" @change="onZoneChange"/>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.region')" prop="region">
              <a-select v-model="location.region.id" :options="regions" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.roadway')" prop="roadway">
              <a-input v-model="location.roadway"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.row')" prop="x">
              <a-input-number v-model="location.x" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.layer')" prop="y">
              <a-input-number v-model="location.y" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.column')" prop="z">
              <a-input-number v-model="location.z" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.depth')" prop="depth">
              <a-input-number v-model="location.depth" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.section')" prop="section">
              <a-input v-model="location.rack.section"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.side')" prop="side">
              <a-input v-model="location.rack.side"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.length')" prop="dimension.length">
              <a-input-number v-model="location.dimension.length" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.width')" prop="dimension.width">
              <a-input-number v-model="location.dimension.width" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.height')" prop="dimension.height">
              <a-input-number v-model="location.dimension.height" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.volume')" prop="dimension.volume">
              <a-input-number v-model="location.dimension.volume" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.weight')" prop="weight">
              <a-input-number v-model="location.weight" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.shortNo')" prop="shortNo">
              <a-input v-model="location.shortNo"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.locationType')" prop="locationType">
              <a-select v-model="location.locationType" :options="locationTypes" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.locationStatus')" prop="locationStatus">
              <a-select v-model="location.locationStatus" :options="locationStatus" disabled/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.rackType')" prop="rackType">
              <a-select v-model="location.rackType" :options="rackTypes" allowClear/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.storageType')" prop="storageType">
              <a-select v-model="location.storageType" :options="storageTypes" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="存放类型上限" prop="limitOfStorageType">
              <a-input-number v-model="location.limitOfStorageType" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.pileupType')" prop="pileupType">
              <a-select v-model="location.pileupType" :options="pileupTypes" allowClear/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.storer')" prop="storer">
              <a-input-search v-model="location.storer.name" readOnly @dblclick="onStorerSelect" @search="onStorerSelect"/>
              <storer-modal ref="storerModal" @change="onStorerChange"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item :label="$t('business.label.saleClassification')" prop="saleClassification">
              <a-select v-model="location.saleClassification" :options="saleClassifications" allowClear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="输送线" prop="conveyor">
              <a-input-search v-model="location.conveyor.name" readOnly @search="()=>this.$refs.conveyorModal.open()"/>
              <field-modal ref="conveyorModal" :no="'CONVEYOR'" :show-value="false" :title="$t('business.label.conveyor')" @change="(conveyor)=>change(conveyor,'conveyor')"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4">
            <a-form-model-item :label="$t('business.label.available')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="location.available" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('business.label.containerControl')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="location.containerControl" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('business.label.automatic')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="location.automatic" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('business.label.locking')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="location.locking" disabled size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('business.label.mechanicalLocking')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="location.mechanicalLocking" disabled size="mini"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>
<script>
import Vue from 'vue'
import { save } from '@/api/Api'
import { WAREHOUSE } from '@/store/mutation-types'
import FieldModal from '@/views/modal/FieldModal.vue'
import StorerModal from '@/views/modal/StorerModal.vue'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import ZoneModal from '@/views/modal/ZoneModal.vue'
import { Location } from '@/api/dto/common/Location'
import { Identifier } from '@/api/dto/Identifier'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Zone } from '@/api/dto/common/Zone'
import { Storer } from '@/api/dto/common/Storer'

export default {
  name: 'LocationEdit',
  components: {
    FieldModal,
    StorerModal,
    ZoneModal,
    StorageRoomModal
  },
  data() {
    return {
      visible: false,
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      location: new Location(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        'no': [{ required: true, message: '编号不能为空' }],
        'name': [{ required: true, message: '名称不能为空' }],
        'storageRoom': [{ required: true, message: '库房不能为空' }],
        'zone': [{ required: true, message: '区域不能为空' }],
        'roadway': [{ required: true, message: '巷道不能为空' }],
        'x': [{ required: true, message: '排不能为空', type: 'number' }],
        'y': [{ required: true, message: '层不能为空', type: 'number' }],
        'z': [{ required: true, message: '列不能为空', type: 'number' }],
        'dimension.length': [{ required: true, message: '长不能为空', type: 'number' }],
        'dimension.width': [{ required: true, message: '宽不能为空', type: 'number' }],
        'dimension.height': [{ required: true, message: '高不能为空', type: 'number' }],
        'dimension.volume': [{ required: true, message: '体积不能为空', type: 'number' }],
        'locationType': [{ required: true, message: '货位类型不能为空' }],
        'storageType': [{ required: true, message: '存放类型不能为空' }],
        'pileupType': [{ required: true, message: '码放类型不能为空' }],
        'saleClassification': [{ required: true, message: '销售分类不能为空' }]
      }
    }
  },
  props: {
    regions: {
      type: Array,
      default: []
    },
    locationTypes: {
      type: Array,
      default: []
    },
    locationStatus: {
      type: Array,
      default: []
    },
    rackTypes: {
      type: Array,
      default: []
    },
    storageTypes: {
      type: Array,
      default: []
    },
    pileupTypes: {
      type: Array,
      default: []
    },
    saleClassifications: {
      type: Array,
      default: []
    }
  },
  methods: {
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open({ available: true })
    },
    onStorageRoomChange(data) {
      this.location.storageRoom = new StorageRoom(data[0])
      this.location.zone = new Zone()
    },
    onZoneSelect() {
      this.$refs.zoneModal.open({ 'storageRoom.id': this.location.storageRoom.id })
    },
    onZoneChange(data) {
      this.location.zone = new Zone(data[0])
    },
    onStorerSelect() {
      this.$refs.storerModal.open({ available: true })
    },
    onStorerChange(data) {
      this.location.storer = new Storer(data[0])
    },
    add() {
      this.edit()
    },
    edit(record) {
      this.visible = true
      this.location = new Location(record)
    },
    save() {
      this.loading = true
      const location = this.location.toJSONObject()
      location.warehouse = this.warehouse
      save('locationPersister', location).then(res => {
        if (res.success) {
          this.location = new Location(res.result)
          this.$message.success('保存成功')
          this.$emit('success')
          this.handleCancel()
        }
      }).finally(() => this.loading = false)
    },
    enable(record, available) {
      this.location = new Location(record)
      this.location.available = available
      this.save()
    },
    change(changeData, fieldName) {
      if (changeData.length === 0) {
        this.location[fieldName] = new Identifier()
      } else {
        this.location[fieldName] = Object.assign(new Identifier(), changeData[0])
      }
    },
    handleOk() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.save()
        }
      })
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>